import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const BusinessNameResultsRoot = superstyled({
  name: 'BusinessNameResults',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    border: `1px solid ${theme.palette.border.main}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    height: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius
  })
});

export const NamesHeader = superstyled({
  name: 'BusinessNameResults',
  slot: 'NamesHeader',
  tag: Box,
  styles: () => ({
    flex: '1',
    display: 'flex',
    flexDirection: 'column'
  })
});

export const NamesContent = superstyled({
  name: 'BusinessNameResults',
  slot: 'NamesContent',
  tag: Box,
  styles: ({ theme }) => ({
    flex: '1',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(2)
    }
  })
});
